import { render, staticRenderFns } from "./GreetingsSelector.vue?vue&type=template&id=1c21c9f5&"
import script from "./GreetingsSelector.vue?vue&type=script&lang=js&"
export * from "./GreetingsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports